module.exports = __webpack_public_path__ + "img/_ico1.42e19578.svg";